__turbopack_context__.v({
  "accessGiftCardButton": "AccessGiftCardButton-module__T5WCRG__accessGiftCardButton",
});
